module.exports = __webpack_public_path__ + "img/1x.758c179.jpg";